import { Warranty } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { t } from '@translations';
import dayjs from 'dayjs';

export const warrantyListColumns = (isBeremaUser?: boolean) => [
  { key: 'id', name: t(TextCodes.Warranty.Block.Id) },
  ...(isBeremaUser ? [{ key: 'customerNo', name: t(TextCodes.Warranty.Block.CustomerNo) }] : []),
  { key: 'createdDate', name: t(TextCodes.Warranty.Block.CreatedDate) },
  { key: 'saleDate', name: t(TextCodes.Warranty.Block.SaleDateCapitalLetter) },
  { key: 'damageDate', name: t(TextCodes.Warranty.Block.DamageDateCapitalLetter) },
  { key: 'brand', name: t(TextCodes.Warranty.Block.Brand) },
  { key: 'claimType', name: t(TextCodes.Warranty.Block.ClaimType) },
  { key: 'status', name: t(TextCodes.Warranty.Block.Status) },
];

export const getWarrantyItems = ({
  warranty,
  isBeremaUser,
}: {
  warranty: Warranty;
  isBeremaUser?: boolean;
}) => [
  {
    fieldName: 'id',
    fieldValue: warranty?.id?.toString(),
    isBold: isBeremaUser ? warranty.isNewForBerema : warranty.isNewForDealer,
  },
  ...(isBeremaUser
    ? [
        {
          fieldName: 'customerNo',
          fieldValue: warranty.customerNo,
          isBold: warranty.isNewForBerema,
        },
      ]
    : []),
  {
    fieldName: 'createdDate',
    fieldValue: dayjs(warranty?.createdDate).format('DD.MM.YYYY'),
    isBold: isBeremaUser ? warranty.isNewForBerema : warranty.isNewForDealer,
  },
  {
    fieldName: 'saleDate',
    fieldValue: warranty?.saleDate ? dayjs(warranty?.saleDate).format('DD.MM.YYYY') : '',
    isBold: isBeremaUser ? warranty.isNewForBerema : warranty.isNewForDealer,
  },
  {
    fieldName: 'damageDate',
    fieldValue: warranty?.damageDate ? dayjs(warranty?.damageDate).format('DD.MM.YYYY') : '',
    isBold: isBeremaUser ? warranty.isNewForBerema : warranty.isNewForDealer,
  },
  {
    fieldName: 'brand',
    fieldValue: warranty.brand,
    isBold: isBeremaUser ? warranty.isNewForBerema : warranty.isNewForDealer,
  },
  {
    fieldName: 'claimType',
    fieldValue: warranty?.claimType ? t(TextCodes.Warranty.ClaimType[warranty.claimType]) : '',
    isBold: isBeremaUser ? warranty.isNewForBerema : warranty.isNewForDealer,
  },
  {
    fieldName: 'status',
    fieldValue: warranty?.status ? t(TextCodes.Warranty.Status[warranty.status]) : '',
    isBold: isBeremaUser ? warranty.isNewForBerema : warranty.isNewForDealer,
  },
];
